import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from './simulatedCorrectionMessages';
import ActionButton from './SimulatedCorrectionAnswerListActionButton';
import SimulatedCorrectionProblemsModal from './SimulatedCorrectionProblemsModal';

import './SimulatedCorrectionAnswerList.scss';

const SimulatedCorrectionAnswerList = props => {
  const [showProblemsModal, setShowProblemsModal] = useState(false);

  // console.log('props.students', props.students);

  // Filtrar alunos com problemas
  const studentsNeedingAudit = props.students.filter(student => 
    student.corrected === '2'
  );
  
  const studentsWithoutCards = props.students.filter(student => 
     student.corrected === null
  );

  // Calcular total de problemas encontrados
  const totalProblems = (studentsNeedingAudit.length > 0 ? 1 : 0) + (studentsWithoutCards.length > 0 ? 1 : 0);

  // Preparar dados para o modal
  const problemsData = {
    auditPending: studentsNeedingAudit.length > 0,
    studentsWithoutCards: studentsWithoutCards.length > 0,
  };

  // Mostrar modal automaticamente quando há problemas
  useEffect(() => {
    if (totalProblems > 0) {
      setShowProblemsModal(true);
    }
  }, [totalProblems]);

  const handleCloseProblemsModal = () => {
    setShowProblemsModal(false);
  };

  return (
    <div className="card correction-answer-list">
      {totalProblems > 0 && (
        <div className="card-header">
          <FormattedMessage {...messages.problemsFound}>
            {txt => (
              <div className="card-header-title">
                <i className="ti-alert" /> {txt}
              </div>
            )}
          </FormattedMessage>
          <span className="badge-status">{totalProblems}</span>
        </div>
      )}
      
      {/* Área expandida de problemas - sempre visível quando há problemas */}
      {totalProblems > 0 && (
        <div className="problems-details-section">
          <div className="problems-description">
            {studentsNeedingAudit.length > 0 && (
              <div className="problem-category">
                • <FormattedHTMLMessage {...messages.auditRequiredInfo} />
              </div>
            )}
            {studentsWithoutCards.length > 0 && (
              <div className="problem-category">
                • <FormattedHTMLMessage {...messages.cardsNotLoadedInfo} />
              </div>
            )}
          </div>
        </div>
      )}
      
      <div className="card-body">
        {props.students.map(student => (
          <div className="card-item">
            <div className="card-item-label">
              <p>
                {student.registration ? `${student.registration} - ` : ''}{student.studentName}
              </p>
            </div>
            <div className="card-item-details">
              <ActionButton
                {...student}
                onSee={() => props.onSee(student)}
                onAudit={() => props.onAudit(student)}
                onUpload={() => props.onUpload(student)}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="total-students"><FormattedMessage {...messages.totalStudents} />: {props.students.length}</div>
      
      {/* Modal de Problemas Encontrados - aparece automaticamente */}
      <SimulatedCorrectionProblemsModal
        show={showProblemsModal}
        onClose={handleCloseProblemsModal}
        problems={problemsData}
      />
    </div>
  );
};

SimulatedCorrectionAnswerList.propTypes = {
  totalWarning: PropTypes.number,
  students: PropTypes.array,
  onSee: PropTypes.func,
  onAudit: PropTypes.func,
  onUpload: PropTypes.func,
};

SimulatedCorrectionAnswerList.defaultProps = {
  students: [],
};

export default SimulatedCorrectionAnswerList;
